import { useMemo } from "react";

import { BucketOfLearninRow } from "./BucketOfLearninRow";
import { useLevelContext } from "sj-ui-toolkit/src/atlas/contexts/Level/LevelContextProvider";
import { sortByEnrollment } from "../../../../helpers/sortByEnrollment";

const getQuestPathId = quest => quest.paths?.slice(-1)[0]?.id ?? quest.role?.id;

export const QuestBucket = ({ currentQuests = [] }) => {
  const { quests, isLoading } = useLevelContext();

  // Order quests: enrolled first, then the rest. See sortByEnrollment for details.
  const orderedQuests = useMemo(() => {
    const items = (quests ?? [])
      .map(quest => {
        const questPathId = getQuestPathId(quest);
        return questPathId == null ? null : { ...quest, id: questPathId };
      })
      .filter(Boolean);
    const enrolledRoleIds = new Set(currentQuests.map(q => q.id));
    return sortByEnrollment(items, enrolledRoleIds) ?? [];
  }, [quests, currentQuests]);

  // viewAllHref is ignored by the legacy row when the upgraded UX flag is off.
  return (
    <div className="my-8">
      <BucketOfLearninRow
        key="quest-row"
        id="quest"
        name="Quests"
        variant="indigo"
        loading={isLoading}
        learnins={orderedQuests}
        pathType="Quest"
        viewAllHref="/quests"
      />
    </div>
  );
};
